import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import { FullImageSectionTeam } from '@/components/Layouts'
import { getImageData } from '@/utilites/getImageData'

const BOX_SX = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'start',
  textAlign: 'start',
  flexDirection: 'column',
  gap: 3,
  width: '100%',
  p: { xs: 2, md: 4, lg: 10 },
}

interface Content {
    title?: string
    subtitle?: string
    image?: string
}

interface S3_team_1Props {
    content?: Content
    blockName?:string
}

const Index = (props: S3_team_1Props) => {
    const { content = {} } = props
    const { title = '', subtitle = '', image = '' } = content
    const heroImage = getImageData(image)

    return (
        <FullImageSectionTeam
            aria-label='S3_team_1'
            image={heroImage.src}
            height={{ xs: '45vh', md: '60vh' }}
            
        >
            <Box sx={BOX_SX}>
                <Typography
                    variant='h1'
                    color='white'
                >
                    {title}
                </Typography>
                <Typography
                    variant='body2'
                    color='white'
                >
                    {subtitle}
                </Typography>
            </Box>
        </FullImageSectionTeam>
    )
}

export default Index
